import React from 'react';
import { BarChart, Bar, XAxis, YAxis,  Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';



// Function to reorder data
const reorderData = (data) => {
  const order = ['Financial', 'Operational', 'Reputational'];
  return data.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
};

const RiskSummary = ({ height, data }) => {
  const reorderedData = data ? reorderData(data) : [];
  //console.log(reorderedData);

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={reorderedData}
        margin={{
          top: 15,
          right: 10,
          left: 10,
          bottom: 0,
        }}
      >

        <XAxis dataKey="name" />
        <YAxis hide/>
        <Tooltip />
        <Legend layout="horizontal" verticalAlign="top" align="center" />  
        <Bar dataKey="Inherent" stackId="a" fill="#F07167" >
          <LabelList dataKey="Inherent" position="insideTop" style={{ fill: 'black' }} />
        </Bar>
        <Bar dataKey="Residual" stackId="a" fill="#FED4AE">
          <LabelList dataKey="Residual" position="insideTop" style={{ fill: 'black' }} />
        </Bar>
        <Bar dataKey="Future" stackId="a" fill="#09A6B0">
          <LabelList dataKey="Future" position="top" style={{ fill: 'black' }} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RiskSummary;